export const DEFAULT_CUTOVER_DATE = '07-01';

/**
 * Returns the season start year for the given reference date.
 * A season runs from the cutover date of one year to the day before the cutover date of the next year.
 * Example: cutoverDate '07-01', referenceDate 2026-08-15 => season 2026
 *          cutoverDate '07-01', referenceDate 2027-03-15 => season 2026
 */
export function getCurrentSeason(cutoverDate: string, referenceDate: Date = new Date()): number {
  const [monthStr, dayStr] = cutoverDate.split('-');
  const cutoverMonth = parseInt(monthStr, 10);
  const cutoverDay = parseInt(dayStr, 10);

  // Use UTC methods to avoid timezone offset issues when Date is constructed from ISO string
  const year = referenceDate.getUTCFullYear();
  const month = referenceDate.getUTCMonth() + 1;
  const day = referenceDate.getUTCDate();

  if (month > cutoverMonth || (month === cutoverMonth && day >= cutoverDay)) {
    return year;
  }
  return year - 1;
}

/**
 * Returns a human-readable season label.
 * For cutoverDate '01-01' (calendar year), returns "2026".
 * For other dates, returns "2026/2027".
 */
export function getSeasonLabel(season: number, cutoverDate: string): string {
  if (cutoverDate === '01-01') {
    return `${season}`;
  }
  return `${season}/${season + 1}`;
}
